export default function handleItemValueCalucation(data) {
  if (data.length === 0) {
    return {
      array: [],
    };
  }

  const hasNegative = data.some((price) => price < 0);

  const TOP_SPACING = hasNegative
    ? 0.1
    : 0.23;

  const CURRENCY = 'EUR';

  const minPrice = Math.min(...data);
  const maxPrice = Math.max(...data);

  const roundUpToNearest = (value, step) => Math.ceil(value / step) * step;

  // Define step sizes based on price range
  const priceRange = maxPrice - minPrice;
  const stepOptions = [
    0.02,
    0.05,
    0.1,
    0.2,
    0.25,
    0.5,
    0.75,
    1,
    1.25,
    1.5,
    2,
    2.25,
    2.5,
    5,
    10,
    20,
  ];
  const stepSize = stepOptions.find((step) => priceRange / 4 <= step) || 20;

  const roundedMax = roundUpToNearest(maxPrice + TOP_SPACING, stepSize);

  let roundedMin;
  let separators;
  let aboveZeroPercentage = 50;
  let belowZeroPercentage = 50;

  if (hasNegative) {
    roundedMin = Math.floor(minPrice / stepSize) * stepSize;
    const step = (roundedMax - roundedMin) / 4;

    separators = Array.from({ length: 5 }, (_, i) => ({
      id: i,
      amount: Math.round((roundedMin + i * step) * 100) / 100,
      amount_currency: CURRENCY,
    }));

    const middleIndex = separators.findIndex((s) => s.amount >= 0);

    if (middleIndex !== -1) {
      separators[middleIndex].amount = 0;

      for (let i = middleIndex - 1; i >= 0; i -= 1) {
        separators[i].amount = Math.round((separators[i + 1].amount - step) * 100) / 100;
      }

      for (let i = middleIndex + 1; i < separators.length; i += 1) {
        separators[i].amount = Math.round((separators[i - 1].amount + step) * 100) / 100;
      }
    }

    aboveZeroPercentage = (separators.filter((e) => e.amount > 0).length / 4) * 100;
    belowZeroPercentage = (separators.filter((e) => e.amount < 0).length / 4) * 100;
  } else {
    roundedMin = 0;
    const step = (roundedMax - roundedMin) / 4;

    separators = Array.from({ length: 5 }, (_, i) => ({
      id: i,
      amount: Math.round((roundedMin + i * step) * 100) / 100,
      amount_currency: CURRENCY,
    }));
  }

  const chartMin = separators.reduce((previous, current) => (
    current.amount < previous.amount ? current : previous
  )).amount;
  const chartMax = separators.reduce((previous, current) => (
    current.amount > previous.amount ? current : previous
  )).amount;

  return {
    array: separators.sort((a, b) => b.amount - a.amount),
    chartMin,
    chartMax,
    roundedMin,
    roundedMax,
    aboveZeroPercentage,
    belowZeroPercentage,
  };
}
